import React from "react";
import SignUpForm from "../../components/signUpForm/SignupForm";

const SignUp = () => {
  return (
    <main className="">
      <section className="container my-0  mx-auto">
        <SignUpForm />
      </section>
    </main>
  );
};

export default SignUp;
